import { useQuery } from "react-query";
import axios from "infra/http";
import { AnexoResponse } from 'core/features/arquivo/typings/index';

function useGetImagensParceiro(id: string) {
    return useQuery(
        `/v1/parceiro/${id}/imagens`,
        async () => {
            const { data } = await axios.get<AnexoResponse[]>(
                `/v1/parceiro/${id}/imagens`
            );

            return data;
        },
        {
            enabled: !!id
        }
    );
}

export default useGetImagensParceiro;
